import { put, takeLatest } from "redux-saga/effects";
import { getListHistoryOrderApi } from "store/api/OrderApi";
import { GET_LIST_HISTORY_ORDER_ACTION } from "../../actions/OrderPageAction/actionTypes";

import * as orderPageAction from "../../actions/OrderPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* getListHistoryOrder(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield getListHistoryOrderApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(orderPageAction.setListHistoryOrderAction(res?.data));
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getListHistoryOrderSaga() {
	yield takeLatest(GET_LIST_HISTORY_ORDER_ACTION, getListHistoryOrder);
}

export default getListHistoryOrderSaga;
